<template>
  <div class="suggest_wrapper">
    <input type="text" placeholder="店舗名・住所・店番など入力" v-model="inputName" @keydown="handleKeyDown($event)" @focus="onFocus()" @blur="onBlur()" ref="input_keyword" inputmode="search">
    <div class="scroll_wrapper" :class="pageType" v-show="isShowSuggest">
      <ul class="suggents suggests_list" ref="suggents">
        <li v-for="(suggest, i) of suggests" :key="suggest.id" :class="{'current': i + 1 === selectSuggestIndex}" @click="selectSuggest($event, suggest)" @tap="selectSuggest($event, suggest)">
          <img src="../../assets/images/common/gray_pin.svg">{{suggest.tenpo}}&nbsp;&nbsp;<span>{{suggest.address}}</span>
        </li>
        <li v-show="suggests.length === 0 && inputName !== ''" class="no_suggest_hits">一致する店舗・ATMはありません</li>
      </ul>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import UtilityService from '../../services/utility-service';
import store from '../../store/store';

export default {
  name: 'Suggest',
  components: {
  },
  directives: {
  },
  props: {
    pageType: String
  },
  data() {
    return {
      inputName: '',
      selectTenpoName: '',
      suggests: [],
      selectSuggestIndex: 0,
      isShowSuggest: false,
      targetSuggest: [],
    };
  },
  computed: {
    pageId: function() {
      return this.id
    },
    shops: function() {
      return store.getters.allStore;
    }
  },
  watch: {
    inputName(newVal, oldVal) {
      if (newVal === '') {
        this.suggests = [];
      } else {
        const filter = _.filter(this.shops, (shop) => {
          if (_.includes(shop.tenpo, newVal) || _.includes(shop.address, newVal) || _.includes(shop.rsv_t9, newVal)) {
            return shop;
          }
        });
        // 店舗名・店番完全一致の場合は先頭へ
        _.forEach(filter, (item, index) => {
          if (item !== undefined) {
            if (item.tenpo === newVal || item.id === newVal) {
              filter.splice(index, index + 1);
              filter.unshift(item);
            }
          }
        });
        
        this.suggests = filter;
        this.targetSuggest = filter;

        this.$emit('suggests', this.suggests);
        this.$emit('inputName', newVal);
      }
    },
    selectSuggestIndex(newVal, oldVal) {
      if (newVal < 0) {
        this.selectSuggestIndex = 0;
      } else if (newVal > _.size(this.suggests)) {
        this.selectSuggestIndex = oldVal;
      }
    },
    suggests(value) {
      this.selectSuggestIndex = 0;
    },
  },
  methods: {
    onFocus() {
      this.isShowSuggest = true;
    },
    onBlur() {
      setTimeout(() => {
        this.isShowSuggest = false;
      }, 200);
    },
    handleKeyDown(event) {
      if (_.size(this.suggests) > 0) {
        switch (event.keyCode) {
          // ↓キー
          case 40:
            this.selectSuggestIndex = ++this.selectSuggestIndex;
            
            this.$nextTick(() => {
              const suggestsElement = this.$refs.suggents;
              const currentSelectElement = suggestsElement.querySelector('.current');
              const suggetAreaHeight = suggestsElement.offsetHeight;
              const scroll = suggestsElement.scrollTop;
              const offset = currentSelectElement.offsetTop + currentSelectElement.offsetHeight;
              const offsetBetween = offset - (scroll + suggetAreaHeight);

              if (offsetBetween >= 0) {
                suggestsElement.scrollTop = Math.abs(offsetBetween) + scroll;
              }
            });
            break;

          // ↑キー
          case 38:
            this.selectSuggestIndex = --this.selectSuggestIndex;

            this.$nextTick(() => {
              const suggestsElement = this.$refs.suggents;
              const currentSelectElement = suggestsElement.querySelector('.current');

              if (currentSelectElement) {
                const offset = currentSelectElement.offsetTop;
                const scroll = suggestsElement.scrollTop;
                const offsetBetween = offset - scroll;

                if (offsetBetween < 0) {
                  suggestsElement.scrollTop = offsetBetween + scroll;
                }
              }
            });
            break;

          // Enterキー
          case 13:
            if (this.selectSuggestIndex > 0) {
              const suggestsElement = this.$refs.suggents;
              const selectSuggestElement = suggestsElement.querySelector('.current');
              if (selectSuggestElement) {
                selectSuggestElement.click();
              } else {
                // 入力済みでEnter時
                if (!_.isEmpty(this.targetSuggest)) {
                  const ids = _.map(this.targetSuggest, 'id');
                  store.dispatch('updateResult', ids);
                  const typeParam = {
                    'type': 'filter',
                    'text': this.inputName
                  }
                  store.dispatch('updateSearchType', typeParam);
                  const input = this.$refs.input_keyword;
                  input.blur();

                  if (this.$router.currentRoute.name === 'Search') {
                    this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
                  } else {
                    this.inputName = '';
                    this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
                  }
                }
              }
            } else {
              // 入力済みでEnter時
              if (!_.isEmpty(this.targetSuggest)) {
                store.dispatch('updateInputName', this.inputName);
                const ids_org = _.map(this.targetSuggest, 'id');
                let ids=_.clone(ids_org)
                if(this.inputName==="天神"){
                  ids=ids_org.filter((d)=>d!="1344"&&d!="244");
                }else if(this.inputName==="博多"){
                  ids=ids_org.filter((d)=>d!="481");
                }
                store.dispatch('updateResult', ids);
                
                const typeParam = {
                  'type': 'filter',
                  'text': this.inputName
                }
                store.dispatch('updateSearchType', typeParam);
                const input = this.$refs.input_keyword;
                input.blur();

                if (this.$router.currentRoute.name === 'Search') {
                  this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
                } else {
                  this.inputName = '';
                  this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
                }
              }
            }
            break;
        }
      }
    },
    selectSuggest(event, suggest) {
      event.preventDefault();
      this.targetSuggest = [];
      this.selectSuggestIndex = 0;
      this.targetSuggest.push(suggest);

      store.dispatch('updateResult', [suggest.id]);

      const typeParam = {
        'type': 'filter',
        'text': suggest.tenpo
      }
      store.dispatch('updateSearchType', typeParam);
      const input = this.$refs.input_keyword;
      input.blur();

      if (this.$router.currentRoute.name === 'Search') {
        this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
      } else {
        this.inputName = '';
        this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
      }
    }
  },
  mounted: function() {
  }
}
</script>
<style lang="scss" scoped>
.suggest_wrapper {
  width: 100%;

  >input {
    appearance: none;
    border: none;
    outline: none;
    line-height: 1;
    width: 100%;
    color: #707070;
    font-size: 14px;
    
    &::placeholder {
      color: #999999;
    }

    @media #{$small} {
      font-size: psd(12);
    }
  }

  .scroll_wrapper {
    padding-right: 4px;
    z-index: 2;
    position: absolute;
    top: calc(100% + 7px);
    bottom: auto;
    left: 0;
    right: 0;
    box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.06);
    border-radius: 3px 3px 8px 8px;
    background: #FFFFFF;
    
    @media #{$small} {
      width: 100%;
      padding-right: psd(4);
      overflow: hidden;
    }

    &.search {
      @media #{$small} {
        width: calc(100% + #{psd(72)});
      }
    }
  }

  ul.suggests_list {
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 200px;

    &::-webkit-scrollbar {
      width: 4px;
      display: block;

      @media #{$small} {
        width: psd(4);
      }
    }

    &::-webkit-scrollbar-thumb {
      background: #D6D6D6;
      border-radius: 2px;
      width: 4px;

      @media #{$small} {
        width: psd(4);
      }
    }

    li {
      width: 100%;
      text-align: left;
      color: #5C5C5C;
      // display: flex;
      // justify-content: flex-start;
      // align-items: center;
      font-size: 14px;
      line-height: 1;
      padding: 10px 32px 10px 14px;
      background: #FFFFFF;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;

      @media #{$small} {
        font-size: psd(14);
        line-height: psd(22);
        padding: 6px psd(8) 6px psd(10);
      }

      &.no_suggest_hits {
        @media #{$small} {
          padding: 12px psd(8) 12px psd(10) !important;
        }
      }

      &:first-of-type {
        padding: 27px 32px 10px 14px;

        @media #{$small} {
          padding: 16px psd(8) 6px psd(10);
        }
      }

      &:last-of-type {
        padding: 10px 32px 19px 14px;

        @media #{$small} {
          padding: 6px psd(8) 6px psd(10);
        }
      }

      img {
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        min-width: 24px;
        max-width: 24px;
        margin-right: 4px;

        @media #{$small} {
          width: psd(24);
          min-width: psd(24);
          max-width: psd(24);
          margin-right: psd(4);
        }
      }

      span {
        color: #999999;
        font-size: 12px;

        @media #{$small} {
          font-size: psd(12);
        }
      }

      &.current {
        color: #FE6B01;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>